export default function SectionIntro({ eyebrow, title, description }) {
  return (
    <div className="section-intro">
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  );
}